<input
  [disabled]="disabled"
  type="checkbox"
  [id]="id"
  [ngModel]="value"
  (ngModelChange)="valueChanged($event)"
  [class.small]="size === possibleSizes.Small"
  [class.mid]="size === possibleSizes.Medium" />
<label [for]="id"><span></span> <label [innerHTML]="label"></label>&nbsp;</label>
